import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import AccountYieldsList from './AccountYieldsList';
import translate from 'components/hoc/translate';

const AccountYieldsListContainer = (props) => {
    const {
        resource,
        translate,
    } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('resources.account_yields.title') } />

                <Actions>
                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <AccountYieldsList
                { ...props }
            />
        </div>
    );
};

AccountYieldsListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(AccountYieldsListContainer);



// WEBPACK FOOTER //
// ./src/pages/account-yields/list/AccountYieldsListContainer.js